// First-visit "Formerly '<old name>'" banner for the Risks/Deviations
// renames (D8). Dismissal is per-storageKey so the two section callouts
// (Potential Issues, Waivers and Tailoring) persist independently, and once
// dismissed the callout never mounts again for that browser.
import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraIconButton, SpecraInlineBanner } from '@mono/ui-components';
import { useState } from 'react';
function isDismissed(storageKey) {
    try {
        return window.localStorage.getItem(storageKey) === 'true';
    } catch  {
        return false;
    }
}
function persistDismissal(storageKey) {
    try {
        window.localStorage.setItem(storageKey, 'true');
    } catch  {
    // Storage unavailable (private mode) — callout reappears next mount.
    }
}
export function SectionRenameCallout({ storageKey, message, testid, dismissTestid }) {
    const [dismissed, setDismissed] = useState(()=>isDismissed(storageKey));
    if (dismissed) return null;
    return /*#__PURE__*/ _jsx(SpecraInlineBanner, {
        "data-testid": testid,
        tone: "info",
        action: /*#__PURE__*/ _jsx(SpecraIconButton, {
            "data-testid": dismissTestid,
            label: "Dismiss",
            size: "sm",
            variant: "ghost",
            onClick: ()=>{
                persistDismissal(storageKey);
                setDismissed(true);
            },
            children: "×"
        }),
        children: message
    });
}
